import React from 'react';
import Cookies from './pages/cookies';
import CookieBanner from './components/CookieBanner';
import ChristmasPopup from './components/ChristmasPopup';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Machines from './pages/Machines';
import Certificates from './pages/Certificates';
import WebProjects from './pages/WebProjects';
import WhyInfinity from './pages/WhyInfinity';
import Contact from './pages/Contact';
import BulgariaProjects from './pages/projects/BulgariaProjects';
import FranceProjects from './pages/projects/FranceProjects';
import KyustendilProject from './pages/projects/KyustendilProject';
import NessebarProject from './pages/projects/NessebarProject';
import PernikOneProject from './pages/projects/PernikOneProject';
import PernikTwoProject from './pages/projects/PernikTwoProject';
import SlivnitsaProject from './pages/projects/SlivnitsaProject';
import RasovoProject from './pages/projects/RasovoProject';
import MoussoulensProject from './pages/projects/MoussoulensProject';
import PerpignanProject from './pages/projects/PerpignanProject';
import StGermainProject from './pages/projects/StGermainProject';
import LesMesProject from './pages/projects/LesMesProject';
import SBRUProject from './pages/projects/SBRUProject';
import LapovoProject from './pages/projects/LapovoProject';
import VitaminkaProject from './pages/projects/VitaminkaProject';
import BelgiumProjects from './pages/projects/BelgiumProjects';
import BelgiumProject from './pages/projects/BelgiumProject';
import GermanyProjects from './pages/projects/GermanyProjects';
import SerbiaProjects from './pages/projects/SerbiaProjects';
import NorthMacedoniaProjects from './pages/projects/NorthMacedoniaProjects';
import ItalyProjects from './pages/projects/ItalyProjects';
import MonrealeProject from './pages/projects/MonrealeProject';
import DieselTechnicProject from './pages/projects/DieselTechnicProject';
import PolchProject from './pages/projects/PolchProject';
import DenmarkProjects from './pages/projects/DenmarkProjects';
import AunslevProject from './pages/projects/AunslevProject';
import VillerupProject from './pages/projects/VillerupProject';
import Login from './pages/Login';
import AdminProjects from './pages/AdminProjects';
import AdminDashboard from './pages/AdminDashboard';
import AdminFields from './pages/AdminFields';
import Dashboard from './pages/Dashboard';
import AdminLayout from './pages/AdminLayout';
import AdminHome from './pages/AdminHome';
import AdminAnalytics from './pages/AdminAnalytics';
import AdminUsers from "./pages/AdminUsers";
import ProjectDetails from "./pages/ProjectDetails";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import AdminResources from "./pages/AdminResources";
import EmployeeProjectDetails from "./pages/EmployeeProjectDetails";
import AdminAssignEmployees from './pages/AdminAssignEmployees';
import AdminDailyLogs from './pages/AdminDailyLogs';
import AllNotifications from "./pages/AllNotifications";
import WorkersPage from './pages/WorkersPage';
import AutoParkPage from './pages/AutoParkPage';
import AdminInventory from './pages/AdminInventory';
import AdminForecasting from './pages/AdminForecasting';
import AdminSettings from './pages/AdminSettings';
import Contracts from './pages/Contracts';

// Employee-specific admin page components
import EmployeeAutoParkPage from './pages/EmployeeAutoParkPage';
import EmployeeInventoryPage from './pages/EmployeeInventoryPage';
import EmployeeContractsPage from './pages/EmployeeContractsPage';

// Finance Components (Isolated in separate directory)
import Invoices from './pages/finance/Invoices';
import InvoiceCreate from './pages/finance/InvoiceCreate';
import InvoiceDetails from './pages/finance/InvoiceDetails';
import CreditNoteDetails from './pages/finance/CreditNoteDetails';
import DebitNoteDetails from './pages/finance/DebitNoteDetails';
import IncomingInvoices from './pages/finance/IncomingInvoices';
import IncomingInvoiceDetails from './pages/finance/IncomingInvoiceDetails';

// Employee Components (Isolated in separate directory)
import EmployeeSchedule from './pages/employee/EmployeeSchedule';
import TimeTracker from './pages/employee/TimeTracker';
import EmployeeReports from './pages/employee/EmployeeReports';
import TeamChat from './pages/employee/TeamChat';
import DigitalForms from './pages/employee/DigitalForms';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-50 via-emerald-50/30 to-slate-50">
          <Navbar />
          <CookieBanner />
          <ChristmasPopup />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/machines" element={<Machines />} />
              <Route path="/certificates" element={<Certificates />} />
              <Route path="/projects" element={<WebProjects />} />
              <Route path="/web-projects" element={<Navigate to="/projects" replace />} />
              <Route path="/projects/bulgaria" element={<BulgariaProjects />} />
              <Route path="/projects/france" element={<FranceProjects />} />
              <Route path="/projects/bulgaria/kyustendil" element={<KyustendilProject />} />
              <Route path="/projects/bulgaria/nessebar" element={<NessebarProject />} />
              <Route path="/projects/bulgaria/pernikone" element={<PernikOneProject />} />
              <Route path="/projects/bulgaria/pernikTwo" element={<PernikTwoProject />} />
              <Route path="/projects/bulgaria/slivnitsa" element={<SlivnitsaProject />} />
              <Route path="/projects/bulgaria/rasovo" element={<RasovoProject />} />
              <Route path="/projects/france/moussoulens" element={<MoussoulensProject />} />
              <Route path="/projects/france/perpignan" element={<PerpignanProject />} />
              <Route path="/projects/france/stgermain" element={<StGermainProject />} />
              <Route path="/projects/france/lesmes" element={<LesMesProject />} />
              <Route path="/projects/france/sbru" element={<SBRUProject />} />
              <Route path="/projects/serbia/lapovo" element={<LapovoProject />} />
	      <Route path="/projects/northmacedonia/vitaminka" element={<VitaminkaProject />} />
              <Route path="/projects/belgium" element={<BelgiumProjects />} />
              <Route path="/projects/belgium/main" element={<BelgiumProject />} />
              <Route path="/projects/germany" element={<GermanyProjects />} />
	      <Route path="/projects/serbia" element={<SerbiaProjects />} />
	      <Route path="/projects/northmacedonia" element={<NorthMacedoniaProjects />} />
              <Route path="/projects/italy" element={<ItalyProjects />} />
              <Route path="/projects/italy/monreale" element={<MonrealeProject />} />
              <Route path="/projects/germany/diesel-technic" element={<DieselTechnicProject />} />
              <Route path="/projects/germany/polch" element={<PolchProject />} />
              <Route path="/projects/denmark" element={<DenmarkProjects />} />
              <Route path="/projects/denmark/aunslev" element={<AunslevProject />} />
              <Route path="/projects/denmark/villerup" element={<VillerupProject />} />
              <Route path="/why-infinity" element={<WhyInfinity />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/projects" element={<AdminProjects />} />
              <Route path="/admin/fields" element={<AdminFields />} />
              
              {/* Employee Routes (Isolated - Never touch admin routes) */}
              <Route path="/employee/dashboard" element={<EmployeeDashboard />} />
              <Route path="/employee/project/:projectId" element={<EmployeeProjectDetails />} />
              <Route path="/employee/schedule" element={<EmployeeSchedule />} />
              <Route path="/employee/time-tracker" element={<TimeTracker />} />
              <Route path="/employee/reports" element={<EmployeeReports />} />
              <Route path="/employee/team-chat" element={<TeamChat />} />
              <Route path="/employee/digital-forms" element={<DigitalForms />} />
              
              {/* Employee Admin Page Access Routes */}
              <Route path="/employee/autopark" element={<EmployeeAutoParkPage />} />
              <Route path="/employee/inventory" element={<EmployeeInventoryPage />} />
              <Route path="/employee/contracts" element={<EmployeeContractsPage />} />
              
              <Route path="/admin/dashboard" element={<AdminLayout />}>
                <Route path="home" element={<AdminHome />} />
                <Route path="projects" element={<AdminProjects />} />
                <Route path="analytics" element={<AdminAnalytics />} />
                <Route path="resources" element={<AdminResources />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="assign" element={<AdminAssignEmployees />} />
                <Route path="projects/:projectId" element={<ProjectDetails />} />
                <Route path="notifications" element={<AllNotifications />} />
                <Route path="daily-logs" element={<AdminDailyLogs />} />
                <Route path="workers" element={<WorkersPage />} />
                <Route path="autopark" element={<AutoParkPage />} />
                <Route path="inventory" element={<AdminInventory />} />
                <Route path="forecasting" element={<AdminForecasting />} />
                <Route path="contracts" element={<Contracts />} />
                <Route path="invoices/create" element={<InvoiceCreate />} />
                <Route path="invoices/:id" element={<InvoiceDetails />} />
                <Route path="invoices" element={<Invoices />} />
                <Route path="incoming-invoices/:id" element={<IncomingInvoiceDetails />} />
                <Route path="incoming-invoices" element={<IncomingInvoices />} />
                <Route path="credit-notes/:id" element={<CreditNoteDetails />} />
                <Route path="debit-notes/:id" element={<DebitNoteDetails />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/cookies" element={<Cookies />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
